const reportTypeToFallbackPage = {
  'cma': 'customise',
  'soi': 'comparable_sales',
  'rental': 'customise',
};

export {
  reportTypeToFallbackPage,
};
